import LenderLoanParticipations from "./LenderLoanParticipations.jsx";

export default LenderLoanParticipations;
